(function() {
    window.apos = window.apos || {};
    var data = document.body && document.body.getAttribute('data-apos');
    Object.assign(window.apos, JSON.parse(data || '{}'));
    if (data) {
      document.body.removeAttribute('data-apos');
    }
    if (window.apos.modules) {
      for (const module of Object.values(window.apos.modules)) {
        if (module.alias) {
          window.apos[module.alias] = module;
        }
      }
    }
})();import index_0App from "/app/node_modules/apostrophe/modules/@apostrophecms/util/ui/src/index.js";


import index_1App from "/app/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/src/index.js";


import index_2App from "/app/node_modules/apostrophe/modules/@apostrophecms/video-widget/ui/src/index.js";


import index_3App from "/app/modules/asset/ui/src/index.js";


import index_4App from "/app/modules/departments/department-page/ui/src/index.js";


import index_5App from "/app/modules/departments/department-fragments/ui/src/index.js";



import index_0Stylesheet from "/app/node_modules/apostrophe/modules/@apostrophecms/image-widget/ui/src/index.scss";


import index_1Stylesheet from "/app/modules/asset/ui/src/index.scss";


import index_2Stylesheet from "/app/modules/root-page/ui/src/index.scss";


import index_3Stylesheet from "/app/modules/persons/person-page/ui/src/index.scss";


import index_4Stylesheet from "/app/modules/club-page/ui/src/index.scss";


import index_5Stylesheet from "/app/modules/async-components/ui/src/index.scss";


import index_6Stylesheet from "/app/modules/persons/person-fragments/ui/src/index.scss";


import index_7Stylesheet from "/app/modules/departments/department-page/ui/src/index.scss";


import index_8Stylesheet from "/app/modules/departments/department-fragments/ui/src/index.scss";


import index_9Stylesheet from "/app/modules/global/global-fragments/ui/src/index.scss";


import index_10Stylesheet from "/app/modules/groups/group-page/ui/src/index.scss";


import index_11Stylesheet from "/app/modules/persons/person-widget/ui/src/index.scss";index_0App();
index_1App();
index_2App();
index_3App();
index_4App();
index_5App();